module.exports = __webpack_public_path__ + "static/media/popular-skycoin-white.8a44720a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/QRCode/images/popular/popular-skycoin-white.png
// module id = 1582
// module chunks = 0